import React, { useState } from 'react';
import { RiMenu3Line, RiCloseLine } from 'react-icons/ri';
import { StudentNavbar, SubjectOverview, SubjectSideNavigation } from '../../../../components';
import math from '../../../../assets/math.webp';

const Mathematics = () => {
  const subjectName = "Mathematics";
  const examType = "BGCSE";
  const [selectedModule, setSelectedModule] = useState({ index: 0, title: { subjectName } });
  const [showModuleMenu, setShowModuleMenu] = useState(false);

  const mathConcepts = [
    "Demonstrate and apply number sense (numeration, patterns, ratios, proportions).",
    "Estimate and understand meaning and connections of the four operations (+, −, ×, ÷).",
    "Use algebraic and analytical methods to describe patterns/relationships and solve problems.",
    "Make and use appropriate measurements and determine acceptable levels of accuracy.",
    "Demonstrate spatial sense and use geometric methods for plane shapes and space figures.",
    "Collect, organize, and analyze data; interpret uncertainty using probability.",
  ];

  const handleModuleSelect = (module) => {
    setSelectedModule(module);
    setShowModuleMenu(false);
  };

  return (
    <div>
      <StudentNavbar />
      <div className="bg-white w-full">
        {/* Responsive grid - 1 column on mobile, 5 columns on desktop */}
        <div className="grid grid-cols-1 lg:grid-cols-5">

          {/* Side Navigation - Hidden on mobile/tablet, visible on large screens */}
          <div className="hidden lg:block lg:col-span-1 text-sm">
            <SubjectSideNavigation
              setSelectedModule={setSelectedModule}
              subjectName={subjectName}
              img={math}
            />
          </div>

          {/* Main Content Area */}
          <div className="col-span-1 lg:col-span-4 bg-[#f0f0f0] min-h-screen px-3 sm:px-5 py-3 sm:py-5 lg:h-[calc(100vh-100px)] overflow-y-auto">

            {/* Mobile Module Dropdown Button */}
            <div className="lg:hidden mb-4">
              <button
                onClick={() => setShowModuleMenu(!showModuleMenu)}
                className="w-full bg-white rounded-lg shadow-sm px-4 py-3 flex items-center justify-between text-gray-700 hover:bg-gray-50 transition"
              >
                <div className="flex items-center gap-3">
                  <img src={math} alt={subjectName} className="h-8 w-8 rounded object-cover" />
                  <span className="font-semibold">{subjectName} Modules</span>
                </div>
                {showModuleMenu ? (
                  <RiCloseLine size={24} className="text-gray-600" />
                ) : (
                  <RiMenu3Line size={24} className="text-gray-600" />
                )}
              </button>

              {/* Dropdown Menu */}
              {showModuleMenu && (
                <div className="mt-2 bg-white rounded-lg shadow-lg overflow-hidden animate-scale-down">
                  <SubjectSideNavigation
                    setSelectedModule={handleModuleSelect}
                    subjectName={subjectName}
                    img={math}
                  />
                </div>
              )}
            </div>

            <SubjectOverview
              subjectName={subjectName}
              examType={examType}
              keyConcepts={mathConcepts}
            />
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes scale-down {
          0% {
            transform: scaleY(0);
            opacity: 0;
            transform-origin: top;
          }
          100% {
            transform: scaleY(1);
            opacity: 1;
            transform-origin: top;
          }
        }
        .animate-scale-down {
          animation: scale-down 0.2s ease-out both;
        }
      `}</style>
    </div>
  );
};

export default Mathematics;